import { useContext } from 'react'

import { ModalContext } from '@/contexts/modal'

interface UseCheckBoxModalProps {
  opened: boolean
  url?: string
  open: (url: string) => void
  close: () => void
}

export const useCheckBoxModal = (): UseCheckBoxModalProps => {
  const { checkBoxModal, setCheckBoxModal } = useContext(ModalContext)

  const open = (url: string) => {
    setCheckBoxModal({
      opened: true,
      url
    })
  }

  const close = () => {
    setCheckBoxModal({
      opened: false
    })
  }

  return {
    open,
    close,
    opened: checkBoxModal?.opened,
    url: checkBoxModal?.url
  }
}
